import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Calendar } from 'lucide-react';
import './Consultation.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function Consultation() {
  const coveragePoints = [
    'O-1 eligibility assessment',
    'Agent vs employer structure analysis',
    'Engagement structuring considerations',
    'Risks, timelines, and expectations',
    'Recommended next steps',
  ];

  return (
    <section id="consultation" className="consultation-section">
      <div className="section-container">
        <motion.div
          className="consultation-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="consultation-icon">
            <Calendar size={32} />
          </div>

          <h2 className="consultation-title">O-1 Visa Advisory Consultation</h2>

          <p className="consultation-description">
            A one-on-one strategic session for individuals evaluating an agent-based O-1 pathway.
          </p>

          <div className="consultation-coverage">
            <h3 className="coverage-label">What's Covered</h3>
            <ul className="coverage-list">
              {coveragePoints.map((point, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: index * 0.08 }}
                >
                  <CheckCircle size={18} />
                  <span>{point}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="consultation-cta"
          >
            Book Your O-1 Advisory Consultation
          </a>

          <p className="consultation-footnote">
            This consultation is strategic and informational and does not constitute legal advice.
          </p>
        </motion.div>
      </div>
    </section>
  );
}

export default Consultation;
